export default {
  tipos_instituicoes: [],
  tipo_instituicao: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
